<template>
  <div class="mt-6 mt-sm-4">
    <ColumnHeader title="Kommentarer" icon="mdi-comment-text-multiple">
      <v-btn class="ml-2" small color="primary" depressed @click="addComment">
        Legg til
      </v-btn>
    </ColumnHeader>
    <AddCommentDialog
      v-model="showAddComment"
      :context="context"
      :tagUsers="tagUsers"
      :desplayShowToCostomerBtn="desplayShowToCostomerBtn"
      @commentAdded="commentAdded"
    />
    <ShowCommentsCards
      :loading="loadingComments"
      :comments="comments"
      :desplayShowToCostomerBtn="desplayShowToCostomerBtn"
      @addComment="addComment"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import commentApi from "@/api/commentApi";
import { valueTypeObject } from "@/types/commentInterface";
import { sortByDate } from "@/helpers/sort";

import AddCommentDialog from "@/components/shared/comments/AddCommentDialog.vue";
import ShowCommentsCards from "@/components/shared/comments/ShowCommentsCards.vue";
import ColumnHeader from "@/components/shared/ColumnHeader.vue";
import { KeyValueExtra } from "@/types/keyValue";
export default Vue.extend({
  props: {
    desplayShowToCostomerBtn: {
      type: Boolean,
      default: false,
    },
    context: {
      type: Object as () => valueTypeObject,
    },
    tagUsers: {
      type: Array as () => Array<KeyValueExtra>,
    },
  },
  data() {
    return {
      showAddComment: false,
      comments: [] as any,
      loadingComments: false,
    };
  },
  methods: {
    getComments(commentsType: valueTypeObject) {
      this.loadingComments = true;
      commentApi.getComments(commentsType).then((response) => {
        this.comments = sortByDate(response, "createdDate");
        this.loadingComments = false;
        this.$emit("comments", this.comments);
      });
    },
    addComment() {
      this.showAddComment = true;
    },
    commentAdded(comment: any) {
      // //Add comment to first of list
      this.comments.unshift(comment);
    },
  },
  components: {
    AddCommentDialog,
    ShowCommentsCards,
    ColumnHeader,
  },
});
</script>
